import { FrameWrapper } from './PreviewFrame.styled'

export const PreviewFrame = ({ result }) => {
  return (
    <FrameWrapper>
      <iframe src={result} title='Redirect' />
    </FrameWrapper>
  )
}
